<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid class="pa-0">
      <v-toolbar class="elevation-1">
        <h4>Visitor</h4>
        <v-spacer></v-spacer>
        <v-btn color="info" class="elevation-0" small @click="handleCreateNew()"
          >Add New</v-btn
        >
      </v-toolbar>
      <v-layout row wrap class="pl-4 pr-4 pt-2">
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Search..."
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                class="elevation-1"
                item-key="name"
              >
                <template slot="items" slot-scope="props">
                  <tr
                    @click="handleMoreInfo(props.item)"
                    style="cursor: pointer;"
                  >
                    <td>
                      <v-avatar size="36px">
                        <img
                          :src="props.item.image"
                          :alt="props.item.username"
                          style="
                            border: solid 1px #e2e2e2;
                            box-shadow: 0 0 5px 0px #868686;
                          "
                        />
                      </v-avatar>
                    </td>
                    <td>
                      <v-chip>{{
                        (props.item.type
                          ? props.item.type
                          : "N/A"
                        ).toUpperCase()
                      }}</v-chip>
                    </td>
                    <td>
                      {{ props.item.full_name }}
                    </td>
                    <td>
                      {{
                        (props.item.mobile || "")
                          .replace(" ", "")
                          .replace(" ", "")
                      }}
                    </td>
                    <td>{{ props.item.email || "N/A" }}</td>
                    <!-- <td>{{ props.item.wwcc_message }}</td> -->
                    <!-- <td align="right">
                      <v-btn
                        color="info"
                        small
                        @click="handleMoreInfo(props.item)"
                        >Edit
                      </v-btn>
                    </td>-->
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import APIVisitor from "@/mixins/APIVisitor";
export default {
  mixins: [APIVisitor],
  data() {
    return {
      search: "",
      complex: {
        selected: [],
        headers: [
          {
            text: "Avatar",
            value: "avatar",
            sortable: false
          },
          {
            text: "Visitor Type",
            value: "type"
          },
          {
            text: "Name",
            value: "full_name"
          },
          {
            text: "Mobile",
            value: "mobile"
          },
          {
            text: "Email",
            value: "email"
          }
        ],
        items: []
      }
    };
  },
  created() {
    this.handleGet();
  },
  methods: {
    handleGet: async function() {
      try {
        let responce = await this.getVisitors();
        this.complex.items = responce.map(obj => {
          if (!obj.image) {
            obj.image = "/static/user@2x.png";
          } else {
            let url = this.baseURL;
            obj.image = url + obj.image;
          }
          obj.full_name = [obj.first_name || "", obj.last_name || ""].join(" ");
          return obj;
        });
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", {
          position: "topCenter"
        });
      }
    },
    handleCreateNew: function() {
      this.$router.push({ name: "Visitor Create", params: { id: 0 } });
    },
    handleMoreInfo: function(row) {
      this.$router.push({
        name: "Visitor Create",
        params: { object: row, id: row._id }
      });
    },
    handleDelete: async function(index, row) {
      let tempTableData = this.complex.items;
      let self = this;
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          let userId = row._id;
          self.deleteRow(tempTableData, index, userId);
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    deleteRow: async function(tempTableData, index, id) {
      if (index >= 0) {
        tempTableData.splice(index, 1);
        try {
          await this.deleteVisitor(id);
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    }
  }
};
</script>
